module.exports = __webpack_public_path__ + "static/media/Amal ibrahim.04b96004.png";